import { render, staticRenderFns } from "./PowerBall.vue?vue&type=template&id=4b7310f7&scoped=true"
import script from "./PowerBall.vue?vue&type=script&lang=js"
export * from "./PowerBall.vue?vue&type=script&lang=js"
import style0 from "./PowerBall.vue?vue&type=style&index=0&id=4b7310f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7310f7",
  null
  
)

export default component.exports